/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	MutationFunction,
	QueryFunction,
	QueryKey,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from '@tanstack/react-query';
import type {
	ArchivalRunParams,
	ArchivalState200,
	ConsumeTrialNoteParams,
	CreateFreemiumCustomerInterestResponse,
	CreatePredictionSessionRequest,
	CreateRetentionPinParams,
	CreateTriageReportParams,
	CreateTriageReportRequest,
	CustomInstructionJobStatusResponse,
	ErrorResponse,
	FreemiumTermsOfServiceAcceptance,
	GenerateCustomInstructionsRequest,
	GenerateCustomInstructionsResponse,
	GetCountOfFreemiumActivities200,
	GetCurrentNoteSnapshot200,
	GetCurrentNoteSnapshotParams,
	GetFreemiumCustomerInterestResponse,
	GetNoteStatus200,
	GetNoteStatusParams,
	GetOutcomeSnapshots200,
	GetSignedNoteJson200,
	GetSignedNoteJsonParams,
	GetTranscriptItemsForNote200,
	GetTranscriptItemsForSessionParams,
	HPIFormat,
	HTTPValidationError,
	InvokePredictionRequest,
	InvokePredictionResponse,
	NoteAssistAction,
	NoteAssistActionPatch,
	NoteFeedbackTriageReport,
	PredictActionsRequest,
	PredictionFeedback,
	PredictionStatusFetch,
	RemainingTrial,
	RemainingTrialForNote,
	RetentionPin,
	RetentionPinRequest,
	Session,
	SoftDeleteActionByUserParams,
	TranscriptItem,
	UpdateActionByUserParams,
	UpdateCustomInstructionsBody,
	UpdatePredictionSessionRequest,
	UserPredictionSettingsInput,
	UserPredictionSettingsOutput,
} from './models';
import { customInstance } from '../core/customInstance';
import type { ErrorType } from '../core/customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Actor Deactivation
 */
export const actorDeactivation = (
	actorTypeName: string,
	actorId: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/actors/${actorTypeName}/${actorId}`,
			method: 'DELETE',
		},
		options,
	);
};

export const getActorDeactivationMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorDeactivation>>,
		TError,
		{ actorTypeName: string; actorId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof actorDeactivation>>,
	TError,
	{ actorTypeName: string; actorId: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof actorDeactivation>>,
		{ actorTypeName: string; actorId: string }
	> = (props) => {
		const { actorTypeName, actorId } = props ?? {};

		return actorDeactivation(actorTypeName, actorId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ActorDeactivationMutationResult = NonNullable<
	Awaited<ReturnType<typeof actorDeactivation>>
>;

export type ActorDeactivationMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Actor Deactivation
 */
export const useActorDeactivation = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorDeactivation>>,
		TError,
		{ actorTypeName: string; actorId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof actorDeactivation>>,
	TError,
	{ actorTypeName: string; actorId: string },
	TContext
> => {
	const mutationOptions = getActorDeactivationMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Actor Reminder
 */
export const actorReminder = (
	actorTypeName: string,
	actorId: string,
	reminderName: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/actors/${actorTypeName}/${actorId}/method/remind/${reminderName}`,
			method: 'PUT',
		},
		options,
	);
};

export const getActorReminderMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorReminder>>,
		TError,
		{ actorTypeName: string; actorId: string; reminderName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof actorReminder>>,
	TError,
	{ actorTypeName: string; actorId: string; reminderName: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof actorReminder>>,
		{ actorTypeName: string; actorId: string; reminderName: string }
	> = (props) => {
		const { actorTypeName, actorId, reminderName } = props ?? {};

		return actorReminder(actorTypeName, actorId, reminderName, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ActorReminderMutationResult = NonNullable<
	Awaited<ReturnType<typeof actorReminder>>
>;

export type ActorReminderMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Actor Reminder
 */
export const useActorReminder = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorReminder>>,
		TError,
		{ actorTypeName: string; actorId: string; reminderName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof actorReminder>>,
	TError,
	{ actorTypeName: string; actorId: string; reminderName: string },
	TContext
> => {
	const mutationOptions = getActorReminderMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Actor Timer
 */
export const actorTimer = (
	actorTypeName: string,
	actorId: string,
	timerName: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/actors/${actorTypeName}/${actorId}/method/timer/${timerName}`,
			method: 'PUT',
		},
		options,
	);
};

export const getActorTimerMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorTimer>>,
		TError,
		{ actorTypeName: string; actorId: string; timerName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof actorTimer>>,
	TError,
	{ actorTypeName: string; actorId: string; timerName: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof actorTimer>>,
		{ actorTypeName: string; actorId: string; timerName: string }
	> = (props) => {
		const { actorTypeName, actorId, timerName } = props ?? {};

		return actorTimer(actorTypeName, actorId, timerName, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ActorTimerMutationResult = NonNullable<
	Awaited<ReturnType<typeof actorTimer>>
>;

export type ActorTimerMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Actor Timer
 */
export const useActorTimer = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorTimer>>,
		TError,
		{ actorTypeName: string; actorId: string; timerName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof actorTimer>>,
	TError,
	{ actorTypeName: string; actorId: string; timerName: string },
	TContext
> => {
	const mutationOptions = getActorTimerMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Actor Method
 */
export const actorMethod = (
	actorTypeName: string,
	actorId: string,
	methodName: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/actors/${actorTypeName}/${actorId}/method/${methodName}`,
			method: 'PUT',
		},
		options,
	);
};

export const getActorMethodMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorMethod>>,
		TError,
		{ actorTypeName: string; actorId: string; methodName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof actorMethod>>,
	TError,
	{ actorTypeName: string; actorId: string; methodName: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof actorMethod>>,
		{ actorTypeName: string; actorId: string; methodName: string }
	> = (props) => {
		const { actorTypeName, actorId, methodName } = props ?? {};

		return actorMethod(actorTypeName, actorId, methodName, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ActorMethodMutationResult = NonNullable<
	Awaited<ReturnType<typeof actorMethod>>
>;

export type ActorMethodMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Actor Method
 */
export const useActorMethod = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof actorMethod>>,
		TError,
		{ actorTypeName: string; actorId: string; methodName: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof actorMethod>>,
	TError,
	{ actorTypeName: string; actorId: string; methodName: string },
	TContext
> => {
	const mutationOptions = getActorMethodMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Dapr Config
 */
export const daprConfig = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{ url: `/gw/note-predictions-api/dapr/config`, method: 'GET', signal },
		options,
	);
};

export const getDaprConfigQueryKey = () => {
	return [`/gw/note-predictions-api/dapr/config`] as const;
};

export const getDaprConfigQueryOptions = <
	TData = Awaited<ReturnType<typeof daprConfig>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof daprConfig>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getDaprConfigQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof daprConfig>>> = ({
		signal,
	}) => daprConfig(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof daprConfig>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type DaprConfigQueryResult = NonNullable<
	Awaited<ReturnType<typeof daprConfig>>
>;
export type DaprConfigQueryError = ErrorType<unknown>;

/**
 * @summary Dapr Config
 */
export const useDaprConfig = <
	TData = Awaited<ReturnType<typeof daprConfig>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof daprConfig>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getDaprConfigQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

export const getGwNotePredictionsApiDocs = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/note-predictions-api/docs`, method: 'GET', signal },
		options,
	);
};

export const getGetGwNotePredictionsApiDocsQueryKey = () => {
	return [`/gw/note-predictions-api/docs`] as const;
};

export const getGetGwNotePredictionsApiDocsQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwNotePredictionsApiDocsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>
	> = ({ signal }) => getGwNotePredictionsApiDocs(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwNotePredictionsApiDocsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>
>;
export type GetGwNotePredictionsApiDocsQueryError = ErrorType<unknown>;

export const useGetGwNotePredictionsApiDocs = <
	TData = Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwNotePredictionsApiDocs>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetGwNotePredictionsApiDocsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Collect Note Prediction Feedback
 */
export const collectNotePredictionFeedback = (
	predictionFeedback: PredictionFeedback,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/feedback`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: predictionFeedback,
		},
		options,
	);
};

export const getCollectNotePredictionFeedbackMutationOptions = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof collectNotePredictionFeedback>>,
		TError,
		{ data: PredictionFeedback },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof collectNotePredictionFeedback>>,
	TError,
	{ data: PredictionFeedback },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof collectNotePredictionFeedback>>,
		{ data: PredictionFeedback }
	> = (props) => {
		const { data } = props ?? {};

		return collectNotePredictionFeedback(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CollectNotePredictionFeedbackMutationResult = NonNullable<
	Awaited<ReturnType<typeof collectNotePredictionFeedback>>
>;
export type CollectNotePredictionFeedbackMutationBody = PredictionFeedback;
export type CollectNotePredictionFeedbackMutationError = ErrorType<
	HTTPValidationError | ErrorResponse
>;

/**
 * @summary Collect Note Prediction Feedback
 */
export const useCollectNotePredictionFeedback = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof collectNotePredictionFeedback>>,
		TError,
		{ data: PredictionFeedback },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof collectNotePredictionFeedback>>,
	TError,
	{ data: PredictionFeedback },
	TContext
> => {
	const mutationOptions =
		getCollectNotePredictionFeedbackMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * The first time a given user calls this, we'll give them some extra notes as a surplus
and notify Sales to reach out.
On subsequent calls, we'll just notify Sales again with no additional surplus notes.

If the user already has the NoteAssist feature flag enabled (i.e. they're a paying
customer), we skip opportunity creation and return 0 surplus.
 * @summary Create Freemium Customer Interest
 */
export const createFreemiumCustomerInterest = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<CreateFreemiumCustomerInterestResponse>(
		{
			url: `/gw/note-predictions-api/freemium/customer-interest`,
			method: 'POST',
		},
		options,
	);
};

export const getCreateFreemiumCustomerInterestMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createFreemiumCustomerInterest>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createFreemiumCustomerInterest>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createFreemiumCustomerInterest>>,
		void
	> = () => {
		return createFreemiumCustomerInterest(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateFreemiumCustomerInterestMutationResult = NonNullable<
	Awaited<ReturnType<typeof createFreemiumCustomerInterest>>
>;

export type CreateFreemiumCustomerInterestMutationError = ErrorType<unknown>;

/**
 * @summary Create Freemium Customer Interest
 */
export const useCreateFreemiumCustomerInterest = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createFreemiumCustomerInterest>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createFreemiumCustomerInterest>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getCreateFreemiumCustomerInterestMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * To be called on Note Assist dialog load, used to determined number of remaining trial notes
and whether the note is enabled for trial. Allows the user to continue scribing into old
notes they've already started even when their quota has been hit for the month.
 * @summary Get Freemium Remaining Trial
 */
export const getFreemiumRemainingTrial = (
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<RemainingTrialForNote>(
		{
			url: `/gw/note-predictions-api/freemium/notes/${noteId}/remaining-trial`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetFreemiumRemainingTrialQueryKey = (noteId: number) => {
	return [
		`/gw/note-predictions-api/freemium/notes/${noteId}/remaining-trial`,
	] as const;
};

export const getGetFreemiumRemainingTrialQueryOptions = <
	TData = Awaited<ReturnType<typeof getFreemiumRemainingTrial>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getFreemiumRemainingTrial>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetFreemiumRemainingTrialQueryKey(noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getFreemiumRemainingTrial>>
	> = ({ signal }) => getFreemiumRemainingTrial(noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getFreemiumRemainingTrial>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetFreemiumRemainingTrialQueryResult = NonNullable<
	Awaited<ReturnType<typeof getFreemiumRemainingTrial>>
>;
export type GetFreemiumRemainingTrialQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Freemium Remaining Trial
 */
export const useGetFreemiumRemainingTrial = <
	TData = Awaited<ReturnType<typeof getFreemiumRemainingTrial>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getFreemiumRemainingTrial>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetFreemiumRemainingTrialQueryOptions(
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * To be called on page load, used to determine the number of remaining trial notes
 * @summary Get Freemium Remaining Trial For User
 */
export const getFreemiumRemainingTrialForUser = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<RemainingTrial>(
		{
			url: `/gw/note-predictions-api/freemium/remaining-trial`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetFreemiumRemainingTrialForUserQueryKey = () => {
	return [`/gw/note-predictions-api/freemium/remaining-trial`] as const;
};

export const getGetFreemiumRemainingTrialForUserQueryOptions = <
	TData = Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetFreemiumRemainingTrialForUserQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>
	> = ({ signal }) => getFreemiumRemainingTrialForUser(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetFreemiumRemainingTrialForUserQueryResult = NonNullable<
	Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>
>;
export type GetFreemiumRemainingTrialForUserQueryError = ErrorType<unknown>;

/**
 * @summary Get Freemium Remaining Trial For User
 */
export const useGetFreemiumRemainingTrialForUser = <
	TData = Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getFreemiumRemainingTrialForUser>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetFreemiumRemainingTrialForUserQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Freemium Terms Of Service Acceptance
 */
export const checkFreemiumTermsOfServiceAcceptance = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<FreemiumTermsOfServiceAcceptance>(
		{
			url: `/gw/note-predictions-api/freemium/terms-of-service`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getCheckFreemiumTermsOfServiceAcceptanceQueryKey = () => {
	return [`/gw/note-predictions-api/freemium/terms-of-service`] as const;
};

export const getCheckFreemiumTermsOfServiceAcceptanceQueryOptions = <
	TData = Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getCheckFreemiumTermsOfServiceAcceptanceQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>
	> = ({ signal }) =>
		checkFreemiumTermsOfServiceAcceptance(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type CheckFreemiumTermsOfServiceAcceptanceQueryResult = NonNullable<
	Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>
>;
export type CheckFreemiumTermsOfServiceAcceptanceQueryError =
	ErrorType<unknown>;

/**
 * @summary Get Freemium Terms Of Service Acceptance
 */
export const useCheckFreemiumTermsOfServiceAcceptance = <
	TData = Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof checkFreemiumTermsOfServiceAcceptance>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getCheckFreemiumTermsOfServiceAcceptanceQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Accept Freemium Terms Of Service
 */
export const acceptFreemiumTermsOfService = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown | void>(
		{
			url: `/gw/note-predictions-api/freemium/terms-of-service`,
			method: 'POST',
		},
		options,
	);
};

export const getAcceptFreemiumTermsOfServiceMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>,
		void
	> = () => {
		return acceptFreemiumTermsOfService(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AcceptFreemiumTermsOfServiceMutationResult = NonNullable<
	Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>
>;

export type AcceptFreemiumTermsOfServiceMutationError = ErrorType<unknown>;

/**
 * @summary Accept Freemium Terms Of Service
 */
export const useAcceptFreemiumTermsOfService = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof acceptFreemiumTermsOfService>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getAcceptFreemiumTermsOfServiceMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Returns whether/when a given user has expressed interest in the Note Assist feature
 * @summary Get Freemium Customer Interest
 */
export const getFreemiumCustomerInterest = (
	userId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetFreemiumCustomerInterestResponse>(
		{
			url: `/gw/note-predictions-api/freemium/user/${userId}/customer-interest`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetFreemiumCustomerInterestQueryKey = (userId: number) => {
	return [
		`/gw/note-predictions-api/freemium/user/${userId}/customer-interest`,
	] as const;
};

export const getGetFreemiumCustomerInterestQueryOptions = <
	TData = Awaited<ReturnType<typeof getFreemiumCustomerInterest>>,
	TError = ErrorType<HTTPValidationError>,
>(
	userId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getFreemiumCustomerInterest>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetFreemiumCustomerInterestQueryKey(userId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getFreemiumCustomerInterest>>
	> = ({ signal }) =>
		getFreemiumCustomerInterest(userId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!userId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getFreemiumCustomerInterest>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetFreemiumCustomerInterestQueryResult = NonNullable<
	Awaited<ReturnType<typeof getFreemiumCustomerInterest>>
>;
export type GetFreemiumCustomerInterestQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Freemium Customer Interest
 */
export const useGetFreemiumCustomerInterest = <
	TData = Awaited<ReturnType<typeof getFreemiumCustomerInterest>>,
	TError = ErrorType<HTTPValidationError>,
>(
	userId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getFreemiumCustomerInterest>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetFreemiumCustomerInterestQueryOptions(
		userId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Db Health
 */
export const getDbHealth = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/note-predictions-api/health/db`, method: 'GET', signal },
		options,
	);
};

export const getGetDbHealthQueryKey = () => {
	return [`/gw/note-predictions-api/health/db`] as const;
};

export const getGetDbHealthQueryOptions = <
	TData = Awaited<ReturnType<typeof getDbHealth>>,
	TError = ErrorType<ErrorResponse>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getDbHealth>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDbHealthQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDbHealth>>> = ({
		signal,
	}) => getDbHealth(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getDbHealth>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetDbHealthQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDbHealth>>
>;
export type GetDbHealthQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get Db Health
 */
export const useGetDbHealth = <
	TData = Awaited<ReturnType<typeof getDbHealth>>,
	TError = ErrorType<ErrorResponse>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getDbHealth>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetDbHealthQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Live
 */
export const getLive = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/note-predictions-api/health/live`, method: 'GET', signal },
		options,
	);
};

export const getGetLiveQueryKey = () => {
	return [`/gw/note-predictions-api/health/live`] as const;
};

export const getGetLiveQueryOptions = <
	TData = Awaited<ReturnType<typeof getLive>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getLive>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetLiveQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getLive>>> = ({
		signal,
	}) => getLive(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getLive>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetLiveQueryResult = NonNullable<
	Awaited<ReturnType<typeof getLive>>
>;
export type GetLiveQueryError = ErrorType<unknown>;

/**
 * @summary Get Live
 */
export const useGetLive = <
	TData = Awaited<ReturnType<typeof getLive>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getLive>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetLiveQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Ready
 */
export const getReady = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/note-predictions-api/health/ready`, method: 'GET', signal },
		options,
	);
};

export const getGetReadyQueryKey = () => {
	return [`/gw/note-predictions-api/health/ready`] as const;
};

export const getGetReadyQueryOptions = <
	TData = Awaited<ReturnType<typeof getReady>>,
	TError = ErrorType<ErrorResponse>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getReady>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetReadyQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getReady>>> = ({
		signal,
	}) => getReady(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getReady>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetReadyQueryResult = NonNullable<
	Awaited<ReturnType<typeof getReady>>
>;
export type GetReadyQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get Ready
 */
export const useGetReady = <
	TData = Awaited<ReturnType<typeof getReady>>,
	TError = ErrorType<ErrorResponse>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof getReady>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetReadyQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Healthz
 */
export const healthz = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{ url: `/gw/note-predictions-api/healthz`, method: 'GET', signal },
		options,
	);
};

export const getHealthzQueryKey = () => {
	return [`/gw/note-predictions-api/healthz`] as const;
};

export const getHealthzQueryOptions = <
	TData = Awaited<ReturnType<typeof healthz>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getHealthzQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof healthz>>> = ({
		signal,
	}) => healthz(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof healthz>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type HealthzQueryResult = NonNullable<
	Awaited<ReturnType<typeof healthz>>
>;
export type HealthzQueryError = ErrorType<unknown>;

/**
 * @summary Healthz
 */
export const useHealthz = <
	TData = Awaited<ReturnType<typeof healthz>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof healthz>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getHealthzQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Get the total number of freemium activities created for the current user.
This only exists for the purposes of integration tests
 * @summary Get Count Of Freemium Activities
 */
export const getCountOfFreemiumActivities = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetCountOfFreemiumActivities200>(
		{
			url: `/gw/note-predictions-api/integration-testing/freemium-activities`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetCountOfFreemiumActivitiesQueryKey = () => {
	return [
		`/gw/note-predictions-api/integration-testing/freemium-activities`,
	] as const;
};

export const getGetCountOfFreemiumActivitiesQueryOptions = <
	TData = Awaited<ReturnType<typeof getCountOfFreemiumActivities>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getCountOfFreemiumActivities>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetCountOfFreemiumActivitiesQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCountOfFreemiumActivities>>
	> = ({ signal }) => getCountOfFreemiumActivities(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getCountOfFreemiumActivities>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetCountOfFreemiumActivitiesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCountOfFreemiumActivities>>
>;
export type GetCountOfFreemiumActivitiesQueryError = ErrorType<unknown>;

/**
 * @summary Get Count Of Freemium Activities
 */
export const useGetCountOfFreemiumActivities = <
	TData = Awaited<ReturnType<typeof getCountOfFreemiumActivities>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getCountOfFreemiumActivities>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetCountOfFreemiumActivitiesQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * This endpoint only exists to facilitate integration testing,
since normally consuming a trial note is a side-effect of calling the /process endpoint
which is undesireable to call in integration tests due to all the side-effects.
 * @summary Consume Trial Note
 */
export const consumeTrialNote = (
	noteId: number,
	params?: ConsumeTrialNoteParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/integration-testing/note/${noteId}/consume-trial-note`,
			method: 'POST',
			params,
		},
		options,
	);
};

export const getConsumeTrialNoteMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof consumeTrialNote>>,
		TError,
		{ noteId: number; params?: ConsumeTrialNoteParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof consumeTrialNote>>,
	TError,
	{ noteId: number; params?: ConsumeTrialNoteParams },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof consumeTrialNote>>,
		{ noteId: number; params?: ConsumeTrialNoteParams }
	> = (props) => {
		const { noteId, params } = props ?? {};

		return consumeTrialNote(noteId, params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ConsumeTrialNoteMutationResult = NonNullable<
	Awaited<ReturnType<typeof consumeTrialNote>>
>;

export type ConsumeTrialNoteMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Consume Trial Note
 */
export const useConsumeTrialNote = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof consumeTrialNote>>,
		TError,
		{ noteId: number; params?: ConsumeTrialNoteParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof consumeTrialNote>>,
	TError,
	{ noteId: number; params?: ConsumeTrialNoteParams },
	TContext
> => {
	const mutationOptions = getConsumeTrialNoteMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Reset Freemium State
 */
export const resetFreemiumState = (
	userId: number,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/integration-testing/user/${userId}/freemium-reset`,
			method: 'POST',
		},
		options,
	);
};

export const getResetFreemiumStateMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resetFreemiumState>>,
		TError,
		{ userId: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof resetFreemiumState>>,
	TError,
	{ userId: number },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof resetFreemiumState>>,
		{ userId: number }
	> = (props) => {
		const { userId } = props ?? {};

		return resetFreemiumState(userId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ResetFreemiumStateMutationResult = NonNullable<
	Awaited<ReturnType<typeof resetFreemiumState>>
>;

export type ResetFreemiumStateMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Reset Freemium State
 */
export const useResetFreemiumState = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resetFreemiumState>>,
		TError,
		{ userId: number },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof resetFreemiumState>>,
	TError,
	{ userId: number },
	TContext
> => {
	const mutationOptions = getResetFreemiumStateMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Archival Cleanup All
 */
export const archivalCleanupAll = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/local_and_dev/archival/cleanup_all`,
			method: 'POST',
		},
		options,
	);
};

export const getArchivalCleanupAllMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalCleanupAll>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof archivalCleanupAll>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof archivalCleanupAll>>,
		void
	> = () => {
		return archivalCleanupAll(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ArchivalCleanupAllMutationResult = NonNullable<
	Awaited<ReturnType<typeof archivalCleanupAll>>
>;

export type ArchivalCleanupAllMutationError = ErrorType<unknown>;

/**
 * @summary Archival Cleanup All
 */
export const useArchivalCleanupAll = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalCleanupAll>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof archivalCleanupAll>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions = getArchivalCleanupAllMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Archival Create Test Data
 */
export const archivalCreateTestData = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/local_and_dev/archival/create_test_data`,
			method: 'POST',
		},
		options,
	);
};

export const getArchivalCreateTestDataMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalCreateTestData>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof archivalCreateTestData>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof archivalCreateTestData>>,
		void
	> = () => {
		return archivalCreateTestData(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ArchivalCreateTestDataMutationResult = NonNullable<
	Awaited<ReturnType<typeof archivalCreateTestData>>
>;

export type ArchivalCreateTestDataMutationError = ErrorType<unknown>;

/**
 * @summary Archival Create Test Data
 */
export const useArchivalCreateTestData = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalCreateTestData>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof archivalCreateTestData>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions = getArchivalCreateTestDataMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Archival Run
 */
export const archivalRun = (
	params: ArchivalRunParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/local_and_dev/archival/run`,
			method: 'POST',
			params,
		},
		options,
	);
};

export const getArchivalRunMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalRun>>,
		TError,
		{ params: ArchivalRunParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof archivalRun>>,
	TError,
	{ params: ArchivalRunParams },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof archivalRun>>,
		{ params: ArchivalRunParams }
	> = (props) => {
		const { params } = props ?? {};

		return archivalRun(params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ArchivalRunMutationResult = NonNullable<
	Awaited<ReturnType<typeof archivalRun>>
>;

export type ArchivalRunMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Archival Run
 */
export const useArchivalRun = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archivalRun>>,
		TError,
		{ params: ArchivalRunParams },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof archivalRun>>,
	TError,
	{ params: ArchivalRunParams },
	TContext
> => {
	const mutationOptions = getArchivalRunMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Archival State
 */
export const archivalState = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<ArchivalState200>(
		{
			url: `/gw/note-predictions-api/local_and_dev/archival/state`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getArchivalStateQueryKey = () => {
	return [`/gw/note-predictions-api/local_and_dev/archival/state`] as const;
};

export const getArchivalStateQueryOptions = <
	TData = Awaited<ReturnType<typeof archivalState>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof archivalState>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getArchivalStateQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof archivalState>>> = ({
		signal,
	}) => archivalState(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof archivalState>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type ArchivalStateQueryResult = NonNullable<
	Awaited<ReturnType<typeof archivalState>>
>;
export type ArchivalStateQueryError = ErrorType<unknown>;

/**
 * @summary Archival State
 */
export const useArchivalState = <
	TData = Awaited<ReturnType<typeof archivalState>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof archivalState>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getArchivalStateQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Can be used from within the integration tests to clean up before/after each test.
Deletes all actions and action predictions, and traces
where the action'shippospace is "integration_test".
 * @summary Delete Actions Integration Test Data
 */
export const deleteActionsIntegrationTestData = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/local_and_dev/delete_actions_integration_test_data`,
			method: 'POST',
		},
		options,
	);
};

export const getDeleteActionsIntegrationTestDataMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>,
		void
	> = () => {
		return deleteActionsIntegrationTestData(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteActionsIntegrationTestDataMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>
>;

export type DeleteActionsIntegrationTestDataMutationError = ErrorType<unknown>;

/**
 * @summary Delete Actions Integration Test Data
 */
export const useDeleteActionsIntegrationTestData = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof deleteActionsIntegrationTestData>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getDeleteActionsIntegrationTestDataMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Endpoint that serves Prometheus metrics.
 * @summary Metrics
 */
export const metrics = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{ url: `/gw/note-predictions-api/metrics`, method: 'GET', signal },
		options,
	);
};

export const getMetricsQueryKey = () => {
	return [`/gw/note-predictions-api/metrics`] as const;
};

export const getMetricsQueryOptions = <
	TData = Awaited<ReturnType<typeof metrics>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getMetricsQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({
		signal,
	}) => metrics(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof metrics>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type MetricsQueryResult = NonNullable<
	Awaited<ReturnType<typeof metrics>>
>;
export type MetricsQueryError = ErrorType<unknown>;

/**
 * @summary Metrics
 */
export const useMetrics = <
	TData = Awaited<ReturnType<typeof metrics>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getMetricsQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Create Mock Transcript Item
 */
export const createMockTranscriptItem = (
	sessionId: string,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/mock-transcript-item/${sessionId}`,
			method: 'POST',
		},
		options,
	);
};

export const getCreateMockTranscriptItemMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createMockTranscriptItem>>,
		TError,
		{ sessionId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createMockTranscriptItem>>,
	TError,
	{ sessionId: string },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createMockTranscriptItem>>,
		{ sessionId: string }
	> = (props) => {
		const { sessionId } = props ?? {};

		return createMockTranscriptItem(sessionId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateMockTranscriptItemMutationResult = NonNullable<
	Awaited<ReturnType<typeof createMockTranscriptItem>>
>;

export type CreateMockTranscriptItemMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Create Mock Transcript Item
 */
export const useCreateMockTranscriptItem = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createMockTranscriptItem>>,
		TError,
		{ sessionId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createMockTranscriptItem>>,
	TError,
	{ sessionId: string },
	TContext
> => {
	const mutationOptions = getCreateMockTranscriptItemMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Get Action Prediction Traces
 */
export const getActionPredictionTraces = (
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/action_traces`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetActionPredictionTracesQueryKey = (noteId: number) => {
	return [`/gw/note-predictions-api/notes/${noteId}/action_traces`] as const;
};

export const getGetActionPredictionTracesQueryOptions = <
	TData = Awaited<ReturnType<typeof getActionPredictionTraces>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionPredictionTraces>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetActionPredictionTracesQueryKey(noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getActionPredictionTraces>>
	> = ({ signal }) => getActionPredictionTraces(noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getActionPredictionTraces>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetActionPredictionTracesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getActionPredictionTraces>>
>;
export type GetActionPredictionTracesQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Action Prediction Traces
 */
export const useGetActionPredictionTraces = <
	TData = Awaited<ReturnType<typeof getActionPredictionTraces>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionPredictionTraces>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetActionPredictionTracesQueryOptions(
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Return the JSON of the current note snapshot.

Uses note_type to determine the correct source:
- VN1: fetches from hippo scribe-snapshot endpoint
- VN2: fetches from visit-notes-api using get_note_2_snapshot

In non-dev/non-local environments, only admin context is allowed.
 * @summary Get Current Note Snapshot
 */
export const getCurrentNoteSnapshot = (
	noteId: number,
	params?: GetCurrentNoteSnapshotParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetCurrentNoteSnapshot200>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/current-note-snapshot`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetCurrentNoteSnapshotQueryKey = (
	noteId: number,
	params?: GetCurrentNoteSnapshotParams,
) => {
	return [
		`/gw/note-predictions-api/notes/${noteId}/current-note-snapshot`,
		...(params ? [params] : []),
	] as const;
};

export const getGetCurrentNoteSnapshotQueryOptions = <
	TData = Awaited<ReturnType<typeof getCurrentNoteSnapshot>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetCurrentNoteSnapshotParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getCurrentNoteSnapshot>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetCurrentNoteSnapshotQueryKey(noteId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCurrentNoteSnapshot>>
	> = ({ signal }) =>
		getCurrentNoteSnapshot(noteId, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getCurrentNoteSnapshot>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetCurrentNoteSnapshotQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCurrentNoteSnapshot>>
>;
export type GetCurrentNoteSnapshotQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Current Note Snapshot
 */
export const useGetCurrentNoteSnapshot = <
	TData = Awaited<ReturnType<typeof getCurrentNoteSnapshot>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetCurrentNoteSnapshotParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getCurrentNoteSnapshot>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetCurrentNoteSnapshotQueryOptions(
		noteId,
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Outcome Snapshots
 */
export const getOutcomeSnapshots = (
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetOutcomeSnapshots200>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/outcome-snapshots`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetOutcomeSnapshotsQueryKey = (noteId: number) => {
	return [
		`/gw/note-predictions-api/notes/${noteId}/outcome-snapshots`,
	] as const;
};

export const getGetOutcomeSnapshotsQueryOptions = <
	TData = Awaited<ReturnType<typeof getOutcomeSnapshots>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOutcomeSnapshots>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetOutcomeSnapshotsQueryKey(noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getOutcomeSnapshots>>
	> = ({ signal }) => getOutcomeSnapshots(noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getOutcomeSnapshots>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetOutcomeSnapshotsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getOutcomeSnapshots>>
>;
export type GetOutcomeSnapshotsQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Outcome Snapshots
 */
export const useGetOutcomeSnapshots = <
	TData = Awaited<ReturnType<typeof getOutcomeSnapshots>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOutcomeSnapshots>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetOutcomeSnapshotsQueryOptions(noteId, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Return the JSON of the signed note.

Uses note_type to determine the correct source:
- VN1: fetches from outcome snapshots (DynamoDB)
- VN2: fetches from visit-notes-api using get_note_2_snapshot

In non-dev/non-local environments, only admin context is allowed.
 * @summary Get Signed Note Json
 */
export const getSignedNoteJson = (
	noteId: number,
	params?: GetSignedNoteJsonParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetSignedNoteJson200>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/signed-note`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetSignedNoteJsonQueryKey = (
	noteId: number,
	params?: GetSignedNoteJsonParams,
) => {
	return [
		`/gw/note-predictions-api/notes/${noteId}/signed-note`,
		...(params ? [params] : []),
	] as const;
};

export const getGetSignedNoteJsonQueryOptions = <
	TData = Awaited<ReturnType<typeof getSignedNoteJson>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetSignedNoteJsonParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSignedNoteJson>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetSignedNoteJsonQueryKey(noteId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getSignedNoteJson>>
	> = ({ signal }) => getSignedNoteJson(noteId, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getSignedNoteJson>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetSignedNoteJsonQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSignedNoteJson>>
>;
export type GetSignedNoteJsonQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Signed Note Json
 */
export const useGetSignedNoteJson = <
	TData = Awaited<ReturnType<typeof getSignedNoteJson>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetSignedNoteJsonParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getSignedNoteJson>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetSignedNoteJsonQueryOptions(
		noteId,
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Return the status of the note (signed/unsigned).

Uses note_type to determine the correct source:
- VN1: checks outcome snapshots for signed status
- VN2: fetches from visit-notes-api to check is_draft status

In non-dev/non-local environments, only admin context is allowed.
 * @summary Get Note Status
 */
export const getNoteStatus = (
	noteId: number,
	params?: GetNoteStatusParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetNoteStatus200>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/status`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetNoteStatusQueryKey = (
	noteId: number,
	params?: GetNoteStatusParams,
) => {
	return [
		`/gw/note-predictions-api/notes/${noteId}/status`,
		...(params ? [params] : []),
	] as const;
};

export const getGetNoteStatusQueryOptions = <
	TData = Awaited<ReturnType<typeof getNoteStatus>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetNoteStatusParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getNoteStatus>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetNoteStatusQueryKey(noteId, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoteStatus>>> = ({
		signal,
	}) => getNoteStatus(noteId, params, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNoteStatus>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNoteStatusQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNoteStatus>>
>;
export type GetNoteStatusQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Note Status
 */
export const useGetNoteStatus = <
	TData = Awaited<ReturnType<typeof getNoteStatus>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	params?: GetNoteStatusParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getNoteStatus>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNoteStatusQueryOptions(noteId, params, options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get New Note Prediction Traces
 */
export const getNewNotePredictionTraces = (
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/traces`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetNewNotePredictionTracesQueryKey = (noteId: number) => {
	return [`/gw/note-predictions-api/notes/${noteId}/traces`] as const;
};

export const getGetNewNotePredictionTracesQueryOptions = <
	TData = Awaited<ReturnType<typeof getNewNotePredictionTraces>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNewNotePredictionTraces>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetNewNotePredictionTracesQueryKey(noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getNewNotePredictionTraces>>
	> = ({ signal }) =>
		getNewNotePredictionTraces(noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!noteId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNewNotePredictionTraces>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNewNotePredictionTracesQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNewNotePredictionTraces>>
>;
export type GetNewNotePredictionTracesQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get New Note Prediction Traces
 */
export const useGetNewNotePredictionTraces = <
	TData = Awaited<ReturnType<typeof getNewNotePredictionTraces>>,
	TError = ErrorType<HTTPValidationError>,
>(
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNewNotePredictionTraces>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNewNotePredictionTracesQueryOptions(
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Create Triage Report
 */
export const createTriageReport = (
	noteId: number,
	createTriageReportRequest: CreateTriageReportRequest,
	params?: CreateTriageReportParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<NoteFeedbackTriageReport>(
		{
			url: `/gw/note-predictions-api/notes/${noteId}/triage`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createTriageReportRequest,
			params,
		},
		options,
	);
};

export const getCreateTriageReportMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createTriageReport>>,
		TError,
		{
			noteId: number;
			data: CreateTriageReportRequest;
			params?: CreateTriageReportParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createTriageReport>>,
	TError,
	{
		noteId: number;
		data: CreateTriageReportRequest;
		params?: CreateTriageReportParams;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createTriageReport>>,
		{
			noteId: number;
			data: CreateTriageReportRequest;
			params?: CreateTriageReportParams;
		}
	> = (props) => {
		const { noteId, data, params } = props ?? {};

		return createTriageReport(noteId, data, params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateTriageReportMutationResult = NonNullable<
	Awaited<ReturnType<typeof createTriageReport>>
>;
export type CreateTriageReportMutationBody = CreateTriageReportRequest;
export type CreateTriageReportMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Triage Report
 */
export const useCreateTriageReport = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createTriageReport>>,
		TError,
		{
			noteId: number;
			data: CreateTriageReportRequest;
			params?: CreateTriageReportParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createTriageReport>>,
	TError,
	{
		noteId: number;
		data: CreateTriageReportRequest;
		params?: CreateTriageReportParams;
	},
	TContext
> => {
	const mutationOptions = getCreateTriageReportMutationOptions(options);

	return useMutation(mutationOptions);
};

export const getGwNotePredictionsApiOpenapiJson = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/gw/note-predictions-api/openapi.json`, method: 'GET', signal },
		options,
	);
};

export const getGetGwNotePredictionsApiOpenapiJsonQueryKey = () => {
	return [`/gw/note-predictions-api/openapi.json`] as const;
};

export const getGetGwNotePredictionsApiOpenapiJsonQueryOptions = <
	TData = Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetGwNotePredictionsApiOpenapiJsonQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>
	> = ({ signal }) =>
		getGwNotePredictionsApiOpenapiJson(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetGwNotePredictionsApiOpenapiJsonQueryResult = NonNullable<
	Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>
>;
export type GetGwNotePredictionsApiOpenapiJsonQueryError = ErrorType<unknown>;

export const useGetGwNotePredictionsApiOpenapiJson = <
	TData = Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getGwNotePredictionsApiOpenapiJson>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions =
		getGetGwNotePredictionsApiOpenapiJsonQueryOptions(options);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Actions For Note
 */
export const getActionsForNote = (
	practiceId: number,
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<NoteAssistAction[]>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetActionsForNoteQueryKey = (
	practiceId: number,
	noteId: number,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions`,
	] as const;
};

export const getGetActionsForNoteQueryOptions = <
	TData = Awaited<ReturnType<typeof getActionsForNote>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionsForNote>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetActionsForNoteQueryKey(practiceId, noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getActionsForNote>>
	> = ({ signal }) =>
		getActionsForNote(practiceId, noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && noteId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getActionsForNote>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetActionsForNoteQueryResult = NonNullable<
	Awaited<ReturnType<typeof getActionsForNote>>
>;
export type GetActionsForNoteQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Actions For Note
 */
export const useGetActionsForNote = <
	TData = Awaited<ReturnType<typeof getActionsForNote>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionsForNote>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetActionsForNoteQueryOptions(
		practiceId,
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * Called when the user writes their own action text. Returns the action prediction ID,
which can be used to look up the action prediction later via the get_action_prediction
endpoint.
 * @summary Predict Actions For Note
 */
export const predictActionsForNote = (
	practiceId: number,
	noteId: number,
	predictActionsRequest: PredictActionsRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<string>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: predictActionsRequest,
		},
		options,
	);
};

export const getPredictActionsForNoteMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof predictActionsForNote>>,
		TError,
		{ practiceId: number; noteId: number; data: PredictActionsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof predictActionsForNote>>,
	TError,
	{ practiceId: number; noteId: number; data: PredictActionsRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof predictActionsForNote>>,
		{ practiceId: number; noteId: number; data: PredictActionsRequest }
	> = (props) => {
		const { practiceId, noteId, data } = props ?? {};

		return predictActionsForNote(practiceId, noteId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PredictActionsForNoteMutationResult = NonNullable<
	Awaited<ReturnType<typeof predictActionsForNote>>
>;
export type PredictActionsForNoteMutationBody = PredictActionsRequest;
export type PredictActionsForNoteMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Predict Actions For Note
 */
export const usePredictActionsForNote = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof predictActionsForNote>>,
		TError,
		{ practiceId: number; noteId: number; data: PredictActionsRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof predictActionsForNote>>,
	TError,
	{ practiceId: number; noteId: number; data: PredictActionsRequest },
	TContext
> => {
	const mutationOptions = getPredictActionsForNoteMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Called when a user clicks the delete button on an action in the shopping cart.
Only soft-deletes the action.
Once the action is deleted, it is no longer eligible for any further AI edits.
 * @summary Soft Delete Action By User
 */
export const softDeleteActionByUser = (
	practiceId: number,
	noteId: number,
	actionId: number,
	params?: SoftDeleteActionByUserParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown | void>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions/${actionId}`,
			method: 'DELETE',
			params,
		},
		options,
	);
};

export const getSoftDeleteActionByUserMutationOptions = <
	TError = ErrorType<void | HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof softDeleteActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params?: SoftDeleteActionByUserParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof softDeleteActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		params?: SoftDeleteActionByUserParams;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof softDeleteActionByUser>>,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params?: SoftDeleteActionByUserParams;
		}
	> = (props) => {
		const { practiceId, noteId, actionId, params } = props ?? {};

		return softDeleteActionByUser(
			practiceId,
			noteId,
			actionId,
			params,
			requestOptions,
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type SoftDeleteActionByUserMutationResult = NonNullable<
	Awaited<ReturnType<typeof softDeleteActionByUser>>
>;

export type SoftDeleteActionByUserMutationError =
	ErrorType<void | HTTPValidationError>;

/**
 * @summary Soft Delete Action By User
 */
export const useSoftDeleteActionByUser = <
	TError = ErrorType<void | HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof softDeleteActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params?: SoftDeleteActionByUserParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof softDeleteActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		params?: SoftDeleteActionByUserParams;
	},
	TContext
> => {
	const mutationOptions = getSoftDeleteActionByUserMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Called when a user submits manual edits for an action in the shopping cart.
Once the action has been manually edited, it is ineligible for any further
AI edits.
 * @summary Patch Action By User
 */
export const patchActionByUser = (
	practiceId: number,
	noteId: number,
	actionId: number,
	noteAssistActionPatch: NoteAssistActionPatch,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<NoteAssistAction>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions/${actionId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: noteAssistActionPatch,
		},
		options,
	);
};

export const getPatchActionByUserMutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof patchActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			data: NoteAssistActionPatch;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof patchActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		data: NoteAssistActionPatch;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof patchActionByUser>>,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			data: NoteAssistActionPatch;
		}
	> = (props) => {
		const { practiceId, noteId, actionId, data } = props ?? {};

		return patchActionByUser(
			practiceId,
			noteId,
			actionId,
			data,
			requestOptions,
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type PatchActionByUserMutationResult = NonNullable<
	Awaited<ReturnType<typeof patchActionByUser>>
>;
export type PatchActionByUserMutationBody = NoteAssistActionPatch;
export type PatchActionByUserMutationError = ErrorType<void>;

/**
 * @summary Patch Action By User
 */
export const usePatchActionByUser = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof patchActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			data: NoteAssistActionPatch;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof patchActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		data: NoteAssistActionPatch;
	},
	TContext
> => {
	const mutationOptions = getPatchActionByUserMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Called when a user submits manual edits for an action in the shopping cart.
Once the action has been manually edited, it is ineligible for any further
AI edits.
 * @summary Update Action By User
 */
export const updateActionByUser = (
	practiceId: number,
	noteId: number,
	actionId: number,
	params: UpdateActionByUserParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<NoteAssistAction>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions/${actionId}`,
			method: 'PUT',
			params,
		},
		options,
	);
};

export const getUpdateActionByUserMutationOptions = <
	TError = ErrorType<void | HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params: UpdateActionByUserParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		params: UpdateActionByUserParams;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateActionByUser>>,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params: UpdateActionByUserParams;
		}
	> = (props) => {
		const { practiceId, noteId, actionId, params } = props ?? {};

		return updateActionByUser(
			practiceId,
			noteId,
			actionId,
			params,
			requestOptions,
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateActionByUserMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateActionByUser>>
>;

export type UpdateActionByUserMutationError =
	ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Action By User
 */
export const useUpdateActionByUser = <
	TError = ErrorType<void | HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateActionByUser>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			actionId: number;
			params: UpdateActionByUserParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateActionByUser>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		actionId: number;
		params: UpdateActionByUserParams;
	},
	TContext
> => {
	const mutationOptions = getUpdateActionByUserMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Can be called by the frontend to check on the status of an ad-hoc action prediction
invoked by the user via the shopping cart text input.
 * @summary Get Actions For Action Prediction Id
 */
export const getActionPrediction = (
	practiceId: number,
	noteId: number,
	actionPredictionId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<NoteAssistAction[] | void>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions/${actionPredictionId}`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetActionPredictionQueryKey = (
	practiceId: number,
	noteId: number,
	actionPredictionId: string,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/actions/${actionPredictionId}`,
	] as const;
};

export const getGetActionPredictionQueryOptions = <
	TData = Awaited<ReturnType<typeof getActionPrediction>>,
	TError = ErrorType<void | HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	actionPredictionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionPrediction>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetActionPredictionQueryKey(practiceId, noteId, actionPredictionId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getActionPrediction>>
	> = ({ signal }) =>
		getActionPrediction(
			practiceId,
			noteId,
			actionPredictionId,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && noteId && actionPredictionId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getActionPrediction>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetActionPredictionQueryResult = NonNullable<
	Awaited<ReturnType<typeof getActionPrediction>>
>;
export type GetActionPredictionQueryError =
	ErrorType<void | HTTPValidationError>;

/**
 * @summary Get Actions For Action Prediction Id
 */
export const useGetActionPrediction = <
	TData = Awaited<ReturnType<typeof getActionPrediction>>,
	TError = ErrorType<void | HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	actionPredictionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getActionPrediction>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetActionPredictionQueryOptions(
		practiceId,
		noteId,
		actionPredictionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Create Retention Pin
 */
export const createRetentionPin = (
	practiceId: number,
	noteId: number,
	retentionPinRequest: RetentionPinRequest,
	params?: CreateRetentionPinParams,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<RetentionPin>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/pin`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: retentionPinRequest,
			params,
		},
		options,
	);
};

export const getCreateRetentionPinMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createRetentionPin>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			data: RetentionPinRequest;
			params?: CreateRetentionPinParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createRetentionPin>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		data: RetentionPinRequest;
		params?: CreateRetentionPinParams;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createRetentionPin>>,
		{
			practiceId: number;
			noteId: number;
			data: RetentionPinRequest;
			params?: CreateRetentionPinParams;
		}
	> = (props) => {
		const { practiceId, noteId, data, params } = props ?? {};

		return createRetentionPin(practiceId, noteId, data, params, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateRetentionPinMutationResult = NonNullable<
	Awaited<ReturnType<typeof createRetentionPin>>
>;
export type CreateRetentionPinMutationBody = RetentionPinRequest;
export type CreateRetentionPinMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Retention Pin
 */
export const useCreateRetentionPin = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createRetentionPin>>,
		TError,
		{
			practiceId: number;
			noteId: number;
			data: RetentionPinRequest;
			params?: CreateRetentionPinParams;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createRetentionPin>>,
	TError,
	{
		practiceId: number;
		noteId: number;
		data: RetentionPinRequest;
		params?: CreateRetentionPinParams;
	},
	TContext
> => {
	const mutationOptions = getCreateRetentionPinMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Get Note Sessions
 */
export const getNoteSessions = (
	practiceId: number,
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<Session[]>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/sessions`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetNoteSessionsQueryKey = (
	practiceId: number,
	noteId: number,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/sessions`,
	] as const;
};

export const getGetNoteSessionsQueryOptions = <
	TData = Awaited<ReturnType<typeof getNoteSessions>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNoteSessions>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetNoteSessionsQueryKey(practiceId, noteId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getNoteSessions>>> = ({
		signal,
	}) => getNoteSessions(practiceId, noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && noteId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNoteSessions>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNoteSessionsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNoteSessions>>
>;
export type GetNoteSessionsQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Note Sessions
 */
export const useGetNoteSessions = <
	TData = Awaited<ReturnType<typeof getNoteSessions>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNoteSessions>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNoteSessionsQueryOptions(
		practiceId,
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Transcript Items For Note
 */
export const getTranscriptItemsForNote = (
	practiceId: number,
	noteId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<GetTranscriptItemsForNote200>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/transcription`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetTranscriptItemsForNoteQueryKey = (
	practiceId: number,
	noteId: number,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/notes/${noteId}/transcription`,
	] as const;
};

export const getGetTranscriptItemsForNoteQueryOptions = <
	TData = Awaited<ReturnType<typeof getTranscriptItemsForNote>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getTranscriptItemsForNote>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTranscriptItemsForNoteQueryKey(practiceId, noteId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTranscriptItemsForNote>>
	> = ({ signal }) =>
		getTranscriptItemsForNote(practiceId, noteId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && noteId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getTranscriptItemsForNote>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetTranscriptItemsForNoteQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTranscriptItemsForNote>>
>;
export type GetTranscriptItemsForNoteQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Transcript Items For Note
 */
export const useGetTranscriptItemsForNote = <
	TData = Awaited<ReturnType<typeof getTranscriptItemsForNote>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	noteId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getTranscriptItemsForNote>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetTranscriptItemsForNoteQueryOptions(
		practiceId,
		noteId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Prediction Session
 */
export const getNotePredictionSession = (
	practiceId: number,
	sessionId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<PredictionStatusFetch>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/sessions/${sessionId}`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetNotePredictionSessionQueryKey = (
	practiceId: number,
	sessionId: string,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/sessions/${sessionId}`,
	] as const;
};

export const getGetNotePredictionSessionQueryOptions = <
	TData = Awaited<ReturnType<typeof getNotePredictionSession>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	sessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetNotePredictionSessionQueryKey(practiceId, sessionId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getNotePredictionSession>>
	> = ({ signal }) =>
		getNotePredictionSession(practiceId, sessionId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && sessionId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNotePredictionSession>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNotePredictionSessionQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNotePredictionSession>>
>;
export type GetNotePredictionSessionQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Prediction Session
 */
export const useGetNotePredictionSession = <
	TData = Awaited<ReturnType<typeof getNotePredictionSession>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	sessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNotePredictionSessionQueryOptions(
		practiceId,
		sessionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Update Prediction Session
 */
export const updatePredictionSession = (
	practiceId: number,
	sessionId: string,
	updatePredictionSessionRequest: UpdatePredictionSessionRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/sessions/${sessionId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: updatePredictionSessionRequest,
		},
		options,
	);
};

export const getUpdatePredictionSessionMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePredictionSession>>,
		TError,
		{
			practiceId: number;
			sessionId: string;
			data: UpdatePredictionSessionRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePredictionSession>>,
	TError,
	{
		practiceId: number;
		sessionId: string;
		data: UpdatePredictionSessionRequest;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePredictionSession>>,
		{
			practiceId: number;
			sessionId: string;
			data: UpdatePredictionSessionRequest;
		}
	> = (props) => {
		const { practiceId, sessionId, data } = props ?? {};

		return updatePredictionSession(practiceId, sessionId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePredictionSessionMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePredictionSession>>
>;
export type UpdatePredictionSessionMutationBody =
	UpdatePredictionSessionRequest;
export type UpdatePredictionSessionMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Update Prediction Session
 */
export const useUpdatePredictionSession = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePredictionSession>>,
		TError,
		{
			practiceId: number;
			sessionId: string;
			data: UpdatePredictionSessionRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updatePredictionSession>>,
	TError,
	{
		practiceId: number;
		sessionId: string;
		data: UpdatePredictionSessionRequest;
	},
	TContext
> => {
	const mutationOptions = getUpdatePredictionSessionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Get Current User Settings
 */
export const getNotePredictionUserSettings = (
	practiceId: number,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<UserPredictionSettingsOutput>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/settings`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetNotePredictionUserSettingsQueryKey = (
	practiceId: number,
) => {
	return [`/gw/note-predictions-api/practices/${practiceId}/settings`] as const;
};

export const getGetNotePredictionUserSettingsQueryOptions = <
	TData = Awaited<ReturnType<typeof getNotePredictionUserSettings>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionUserSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetNotePredictionUserSettingsQueryKey(practiceId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getNotePredictionUserSettings>>
	> = ({ signal }) =>
		getNotePredictionUserSettings(practiceId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!practiceId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNotePredictionUserSettings>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNotePredictionUserSettingsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNotePredictionUserSettings>>
>;
export type GetNotePredictionUserSettingsQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Current User Settings
 */
export const useGetNotePredictionUserSettings = <
	TData = Awaited<ReturnType<typeof getNotePredictionUserSettings>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionUserSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNotePredictionUserSettingsQueryOptions(
		practiceId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Patch User Settings
 */
export const patchNotePredictionUserSettings = (
	practiceId: number,
	userPredictionSettingsInput: UserPredictionSettingsInput,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UserPredictionSettingsOutput>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/settings`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: userPredictionSettingsInput,
		},
		options,
	);
};

export const getPatchNotePredictionUserSettingsMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof patchNotePredictionUserSettings>>,
		TError,
		{ practiceId: number; data: UserPredictionSettingsInput },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof patchNotePredictionUserSettings>>,
	TError,
	{ practiceId: number; data: UserPredictionSettingsInput },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof patchNotePredictionUserSettings>>,
		{ practiceId: number; data: UserPredictionSettingsInput }
	> = (props) => {
		const { practiceId, data } = props ?? {};

		return patchNotePredictionUserSettings(practiceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PatchNotePredictionUserSettingsMutationResult = NonNullable<
	Awaited<ReturnType<typeof patchNotePredictionUserSettings>>
>;
export type PatchNotePredictionUserSettingsMutationBody =
	UserPredictionSettingsInput;
export type PatchNotePredictionUserSettingsMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Patch User Settings
 */
export const usePatchNotePredictionUserSettings = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof patchNotePredictionUserSettings>>,
		TError,
		{ practiceId: number; data: UserPredictionSettingsInput },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof patchNotePredictionUserSettings>>,
	TError,
	{ practiceId: number; data: UserPredictionSettingsInput },
	TContext
> => {
	const mutationOptions =
		getPatchNotePredictionUserSettingsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Update User Settings
 */
export const updateNotePredictionUserSettings = (
	practiceId: number,
	userPredictionSettingsInput: UserPredictionSettingsInput,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<UserPredictionSettingsOutput>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/settings`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: userPredictionSettingsInput,
		},
		options,
	);
};

export const getUpdateNotePredictionUserSettingsMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateNotePredictionUserSettings>>,
		TError,
		{ practiceId: number; data: UserPredictionSettingsInput },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateNotePredictionUserSettings>>,
	TError,
	{ practiceId: number; data: UserPredictionSettingsInput },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateNotePredictionUserSettings>>,
		{ practiceId: number; data: UserPredictionSettingsInput }
	> = (props) => {
		const { practiceId, data } = props ?? {};

		return updateNotePredictionUserSettings(practiceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateNotePredictionUserSettingsMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateNotePredictionUserSettings>>
>;
export type UpdateNotePredictionUserSettingsMutationBody =
	UserPredictionSettingsInput;
export type UpdateNotePredictionUserSettingsMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Update User Settings
 */
export const useUpdateNotePredictionUserSettings = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateNotePredictionUserSettings>>,
		TError,
		{ practiceId: number; data: UserPredictionSettingsInput },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateNotePredictionUserSettings>>,
	TError,
	{ practiceId: number; data: UserPredictionSettingsInput },
	TContext
> => {
	const mutationOptions =
		getUpdateNotePredictionUserSettingsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Update Custom Instructions
 */
export const updateCustomInstructions = (
	practiceId: number,
	updateCustomInstructionsBody: UpdateCustomInstructionsBody,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<void>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/settings/features/custom_instructions`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: updateCustomInstructionsBody,
		},
		options,
	);
};

export const getUpdateCustomInstructionsMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateCustomInstructions>>,
		TError,
		{ practiceId: number; data: UpdateCustomInstructionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateCustomInstructions>>,
	TError,
	{ practiceId: number; data: UpdateCustomInstructionsBody },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateCustomInstructions>>,
		{ practiceId: number; data: UpdateCustomInstructionsBody }
	> = (props) => {
		const { practiceId, data } = props ?? {};

		return updateCustomInstructions(practiceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateCustomInstructionsMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateCustomInstructions>>
>;
export type UpdateCustomInstructionsMutationBody = UpdateCustomInstructionsBody;
export type UpdateCustomInstructionsMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Update Custom Instructions
 */
export const useUpdateCustomInstructions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateCustomInstructions>>,
		TError,
		{ practiceId: number; data: UpdateCustomInstructionsBody },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateCustomInstructions>>,
	TError,
	{ practiceId: number; data: UpdateCustomInstructionsBody },
	TContext
> => {
	const mutationOptions = getUpdateCustomInstructionsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Update Hpi Format
 */
export const updateHpiFormat = (
	practiceId: number,
	hPIFormat: HPIFormat,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<void>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/settings/features/hpi_format`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: hPIFormat,
		},
		options,
	);
};

export const getUpdateHpiFormatMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateHpiFormat>>,
		TError,
		{ practiceId: number; data: HPIFormat },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateHpiFormat>>,
	TError,
	{ practiceId: number; data: HPIFormat },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateHpiFormat>>,
		{ practiceId: number; data: HPIFormat }
	> = (props) => {
		const { practiceId, data } = props ?? {};

		return updateHpiFormat(practiceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateHpiFormatMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateHpiFormat>>
>;
export type UpdateHpiFormatMutationBody = HPIFormat;
export type UpdateHpiFormatMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Update Hpi Format
 */
export const useUpdateHpiFormat = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateHpiFormat>>,
		TError,
		{ practiceId: number; data: HPIFormat },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof updateHpiFormat>>,
	TError,
	{ practiceId: number; data: HPIFormat },
	TContext
> => {
	const mutationOptions = getUpdateHpiFormatMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Get Transcript Items For Session
 */
export const getTranscriptItemsForSession = (
	practiceId: number,
	sessionId: string,
	params?: GetTranscriptItemsForSessionParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<TranscriptItem[]>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/transcription/${sessionId}`,
			method: 'GET',
			params,
			signal,
		},
		options,
	);
};

export const getGetTranscriptItemsForSessionQueryKey = (
	practiceId: number,
	sessionId: string,
	params?: GetTranscriptItemsForSessionParams,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/transcription/${sessionId}`,
		...(params ? [params] : []),
	] as const;
};

export const getGetTranscriptItemsForSessionQueryOptions = <
	TData = Awaited<ReturnType<typeof getTranscriptItemsForSession>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	sessionId: string,
	params?: GetTranscriptItemsForSessionParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getTranscriptItemsForSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetTranscriptItemsForSessionQueryKey(practiceId, sessionId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getTranscriptItemsForSession>>
	> = ({ signal }) =>
		getTranscriptItemsForSession(
			practiceId,
			sessionId,
			params,
			requestOptions,
			signal,
		);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && sessionId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getTranscriptItemsForSession>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetTranscriptItemsForSessionQueryResult = NonNullable<
	Awaited<ReturnType<typeof getTranscriptItemsForSession>>
>;
export type GetTranscriptItemsForSessionQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Transcript Items For Session
 */
export const useGetTranscriptItemsForSession = <
	TData = Awaited<ReturnType<typeof getTranscriptItemsForSession>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	sessionId: string,
	params?: GetTranscriptItemsForSessionParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getTranscriptItemsForSession>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetTranscriptItemsForSessionQueryOptions(
		practiceId,
		sessionId,
		params,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Get Custom Instruction Job
 */
export const getCustomInstructionJob = (
	practiceId: number,
	userId: number,
	jobId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<CustomInstructionJobStatusResponse>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/users/${userId}/custom-instruction-jobs/${jobId}`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetCustomInstructionJobQueryKey = (
	practiceId: number,
	userId: number,
	jobId: string,
) => {
	return [
		`/gw/note-predictions-api/practices/${practiceId}/users/${userId}/custom-instruction-jobs/${jobId}`,
	] as const;
};

export const getGetCustomInstructionJobQueryOptions = <
	TData = Awaited<ReturnType<typeof getCustomInstructionJob>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	userId: number,
	jobId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getCustomInstructionJob>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetCustomInstructionJobQueryKey(practiceId, userId, jobId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCustomInstructionJob>>
	> = ({ signal }) =>
		getCustomInstructionJob(practiceId, userId, jobId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!(practiceId && userId && jobId),
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getCustomInstructionJob>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetCustomInstructionJobQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCustomInstructionJob>>
>;
export type GetCustomInstructionJobQueryError = ErrorType<HTTPValidationError>;

/**
 * @summary Get Custom Instruction Job
 */
export const useGetCustomInstructionJob = <
	TData = Awaited<ReturnType<typeof getCustomInstructionJob>>,
	TError = ErrorType<HTTPValidationError>,
>(
	practiceId: number,
	userId: number,
	jobId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getCustomInstructionJob>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetCustomInstructionJobQueryOptions(
		practiceId,
		userId,
		jobId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Generate Custom Instructions
 */
export const generateCustomInstructions = (
	practiceId: number,
	userId: number,
	generateCustomInstructionsRequest: GenerateCustomInstructionsRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<GenerateCustomInstructionsResponse>(
		{
			url: `/gw/note-predictions-api/practices/${practiceId}/users/${userId}/generate-custom-instructions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: generateCustomInstructionsRequest,
		},
		options,
	);
};

export const getGenerateCustomInstructionsMutationOptions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof generateCustomInstructions>>,
		TError,
		{
			practiceId: number;
			userId: number;
			data: GenerateCustomInstructionsRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof generateCustomInstructions>>,
	TError,
	{
		practiceId: number;
		userId: number;
		data: GenerateCustomInstructionsRequest;
	},
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof generateCustomInstructions>>,
		{
			practiceId: number;
			userId: number;
			data: GenerateCustomInstructionsRequest;
		}
	> = (props) => {
		const { practiceId, userId, data } = props ?? {};

		return generateCustomInstructions(practiceId, userId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type GenerateCustomInstructionsMutationResult = NonNullable<
	Awaited<ReturnType<typeof generateCustomInstructions>>
>;
export type GenerateCustomInstructionsMutationBody =
	GenerateCustomInstructionsRequest;
export type GenerateCustomInstructionsMutationError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Generate Custom Instructions
 */
export const useGenerateCustomInstructions = <
	TError = ErrorType<HTTPValidationError>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof generateCustomInstructions>>,
		TError,
		{
			practiceId: number;
			userId: number;
			data: GenerateCustomInstructionsRequest;
		},
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof generateCustomInstructions>>,
	TError,
	{
		practiceId: number;
		userId: number;
		data: GenerateCustomInstructionsRequest;
	},
	TContext
> => {
	const mutationOptions = getGenerateCustomInstructionsMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Run an "on-demand" manual note prediction.

Normally predictions are run periodically on chunks of transcript that are
streamed in realtime. This endpoint lets you run a prediction at once.

If a transcript is provided, it will be used. If transcript is None or empty,
the system will automatically use unprocessed existing transcript items from
all sessions of the note.

Can be used for retries or for manual predictions.
 * @summary Run Manual Prediction
 */
export const runManualPrediction = (
	invokePredictionRequest: InvokePredictionRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<InvokePredictionResponse>(
		{
			url: `/gw/note-predictions-api/predict-complete-transcript`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: invokePredictionRequest,
		},
		options,
	);
};

export const getRunManualPredictionMutationOptions = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof runManualPrediction>>,
		TError,
		{ data: InvokePredictionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof runManualPrediction>>,
	TError,
	{ data: InvokePredictionRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof runManualPrediction>>,
		{ data: InvokePredictionRequest }
	> = (props) => {
		const { data } = props ?? {};

		return runManualPrediction(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type RunManualPredictionMutationResult = NonNullable<
	Awaited<ReturnType<typeof runManualPrediction>>
>;
export type RunManualPredictionMutationBody = InvokePredictionRequest;
export type RunManualPredictionMutationError = ErrorType<
	HTTPValidationError | ErrorResponse
>;

/**
 * @summary Run Manual Prediction
 */
export const useRunManualPrediction = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof runManualPrediction>>,
		TError,
		{ data: InvokePredictionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof runManualPrediction>>,
	TError,
	{ data: InvokePredictionRequest },
	TContext
> => {
	const mutationOptions = getRunManualPredictionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * @summary Create Prediction Session
 */
export const createPredictionSession = (
	createPredictionSessionRequest: CreatePredictionSessionRequest,
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{
			url: `/gw/note-predictions-api/process`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: createPredictionSessionRequest,
		},
		options,
	);
};

export const getCreatePredictionSessionMutationOptions = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPredictionSession>>,
		TError,
		{ data: CreatePredictionSessionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createPredictionSession>>,
	TError,
	{ data: CreatePredictionSessionRequest },
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createPredictionSession>>,
		{ data: CreatePredictionSessionRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createPredictionSession(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreatePredictionSessionMutationResult = NonNullable<
	Awaited<ReturnType<typeof createPredictionSession>>
>;
export type CreatePredictionSessionMutationBody =
	CreatePredictionSessionRequest;
export type CreatePredictionSessionMutationError = ErrorType<
	HTTPValidationError | ErrorResponse
>;

/**
 * @summary Create Prediction Session
 */
export const useCreatePredictionSession = <
	TError = ErrorType<HTTPValidationError | ErrorResponse>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPredictionSession>>,
		TError,
		{ data: CreatePredictionSessionRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof createPredictionSession>>,
	TError,
	{ data: CreatePredictionSessionRequest },
	TContext
> => {
	const mutationOptions = getCreatePredictionSessionMutationOptions(options);

	return useMutation(mutationOptions);
};

/**
 * Get the snapshot of the user's settings that were used for a given session.
This unauthenticated route is meant for use by the dashboard.
 * @summary Get Prediction Session Settings Snapshot
 */
export const getNotePredictionSessionSettingsSnapshot = (
	sessionId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<UserPredictionSettingsOutput>(
		{
			url: `/gw/note-predictions-api/sessions/${sessionId}/settings-snapshot`,
			method: 'GET',
			signal,
		},
		options,
	);
};

export const getGetNotePredictionSessionSettingsSnapshotQueryKey = (
	sessionId: string,
) => {
	return [
		`/gw/note-predictions-api/sessions/${sessionId}/settings-snapshot`,
	] as const;
};

export const getGetNotePredictionSessionSettingsSnapshotQueryOptions = <
	TData = Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>,
	TError = ErrorType<HTTPValidationError>,
>(
	sessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetNotePredictionSessionSettingsSnapshotQueryKey(sessionId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>
	> = ({ signal }) =>
		getNotePredictionSessionSettingsSnapshot(sessionId, requestOptions, signal);

	return {
		queryKey,
		queryFn,
		enabled: !!sessionId,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>,
		TError,
		TData
	> & { queryKey: QueryKey };
};

export type GetNotePredictionSessionSettingsSnapshotQueryResult = NonNullable<
	Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>
>;
export type GetNotePredictionSessionSettingsSnapshotQueryError =
	ErrorType<HTTPValidationError>;

/**
 * @summary Get Prediction Session Settings Snapshot
 */
export const useGetNotePredictionSessionSettingsSnapshot = <
	TData = Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>,
	TError = ErrorType<HTTPValidationError>,
>(
	sessionId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getNotePredictionSessionSettingsSnapshot>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
	const queryOptions = getGetNotePredictionSessionSettingsSnapshotQueryOptions(
		sessionId,
		options,
	);

	const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
		queryKey: QueryKey;
	};

	query.queryKey = queryOptions.queryKey;

	return query;
};

/**
 * @summary Archive Note Prediction Traces
 */
export const archiveNotePredictionTraces = (
	options?: SecondParameter<typeof customInstance>,
) => {
	return customInstance<unknown>(
		{ url: `/gw/note-predictions-api/test_archiving_traces`, method: 'POST' },
		options,
	);
};

export const getArchiveNotePredictionTracesMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archiveNotePredictionTraces>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof archiveNotePredictionTraces>>,
	TError,
	void,
	TContext
> => {
	const { mutation: mutationOptions, request: requestOptions } = options ?? {};

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof archiveNotePredictionTraces>>,
		void
	> = () => {
		return archiveNotePredictionTraces(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ArchiveNotePredictionTracesMutationResult = NonNullable<
	Awaited<ReturnType<typeof archiveNotePredictionTraces>>
>;

export type ArchiveNotePredictionTracesMutationError = ErrorType<unknown>;

/**
 * @summary Archive Note Prediction Traces
 */
export const useArchiveNotePredictionTraces = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof archiveNotePredictionTraces>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationResult<
	Awaited<ReturnType<typeof archiveNotePredictionTraces>>,
	TError,
	void,
	TContext
> => {
	const mutationOptions =
		getArchiveNotePredictionTracesMutationOptions(options);

	return useMutation(mutationOptions);
};
